/**
 * InstallationRpcClient - AtomRpc integration for the customer-facing,
 * authenticated installation endpoints (`installations.*`). Used by
 * `/codex-connect` to resolve the caller's connectable installs via
 * `installations.list` (the backend reads `CurrentActor`). Clerk-authed.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallationRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class InstallationRpcClient extends AtomRpc.Tag<InstallationRpcClient>()(
  "InstallationRpcClient",
  {
    group: InstallationRpcs,
    protocol: makeRpcClientLayer(InstallationRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
